export const CALENDAR_TYPE = {
  office365: 'office365',
  exchange: 'exchange',
  icloud: 'icloud',
  google: 'google',
  caldav: 'caldav',
  ics: 'ics',
  calenso: 'calenso'
};

export const CALENDAR_TYPE_NAMES = {
  office365: 'Office365',
  exchange: 'Microsoft Exchange',
  icloud: 'iCloud',
  google: 'Google Calendar',
  caldav: 'CalDAV',
  ics: 'ICS subscription',
  calenso: 'Calenso'
};

export const CALENDAR_TYPE_IMAGE_PATH = {
  office365: '/assets/images/calendar/microsoft365-icon.svg',
  exchange: '/assets/images/calendar/exchange-icon.svg',
  icloud: '/assets/images/calendar/icloud-icon.svg',
  google: '/assets/images/calendar/google-icon.svg',
  caldav: '/assets/images/calendar/caldav-icon.svg',
  ics: '/assets/images/calendar/ics-icon.svg',
  calenso: '/assets/images/brand/calendar-icon.svg'
};

export const CALENDAR_TYPE_LIST_WITH_PERMISSIONS = [
  {
    name: CALENDAR_TYPE_NAMES.office365,
    value: CALENDAR_TYPE.office365,
    image: CALENDAR_TYPE_IMAGE_PATH.office365,
    requiredFeature: 'is_office365_enabled',
    disabled: false
  },
  {
    name: CALENDAR_TYPE_NAMES.exchange,
    value: CALENDAR_TYPE.exchange,
    image: CALENDAR_TYPE_IMAGE_PATH.exchange,
    requiredFeature: 'is_exchange_calendar_enabled',
    disabled: false
  },
  {
    name: CALENDAR_TYPE_NAMES.icloud,
    value: CALENDAR_TYPE.icloud,
    image: CALENDAR_TYPE_IMAGE_PATH.icloud,
    requiredFeature: 'is_icloud_enabled',
    disabled: false
  },
  {
    name: CALENDAR_TYPE_NAMES.google,
    value: CALENDAR_TYPE.google,
    image: CALENDAR_TYPE_IMAGE_PATH.google,
    requiredFeature: 'is_google_calendar_enabled',
    disabled: false
  },
  {
    name: CALENDAR_TYPE_NAMES.caldav,
    value: CALENDAR_TYPE.caldav,
    image: CALENDAR_TYPE_IMAGE_PATH.caldav,
    requiredFeature: 'is_caldav_calendar_enabled',
    disabled: false
  },
  {
    name: CALENDAR_TYPE_NAMES.ics,
    value: CALENDAR_TYPE.ics,
    image: CALENDAR_TYPE_IMAGE_PATH.ics,
    disabled: false
  },
  {
    name: CALENDAR_TYPE_NAMES.calenso,
    value: CALENDAR_TYPE.calenso,
    image: CALENDAR_TYPE_IMAGE_PATH.calenso,
    disabled: false
  }
];

export const CALDAV_PROVIDERS = {
  infomaniak: 'Infomaniak',
  nextcloud: 'NextCloud',
  owncloud: 'OwnCloud',
  zimbra: 'Zimbra',
  hostpoint: 'Hostpoint',
};

export const CALENDAR_COLOR_CONSTANT = [
  {
    key: 'white',
    value: '#ffffff',
  },
  {
    key: 'black',
    value: '#000000',
  },
  {
    key: 'red',
    value: '#fad9d5',
  },
  {
    key: 'vacation',
    value: 'background: repeating-linear-gradient(45deg, rgba(155, 155, 155, 0.5), rgba(155, 155, 155, 0.5) 8px, transparent 8px, transparent 16px);color: #666;',
  },
  {
    key: 'green',
    value: '#d2f6d5',
  },
  {
    key: 'blue',
    value: '#AACDFC',
  },
  {
    key: 'violett',
    value: '#B1B2FD',
  },
  {
    key: 'orange',
    value: '#ffeed6',
  },
  {
    key: 'yellow',
    value: '#ffee9a',
  },
  {
    key: 'google',
    value: '#9A9DA2',
  },
  {
    key: 'icloud',
    value: '#9A9DA2',
  },
  {
    key: 'exchange',
    value: '#9A9DA2',
  },
  {
    key: 'office365',
    value: '#9A9DA2',
  },
  {
    key: 'external',
    value: '#9A9DA2',
  },
];

export const CALENDAR_DEFAULT_VIEW = [
  {
    value: 'day',
    display: 'workflow.day'
  },
  {
    value: 'week',
    display: 'workflow.week'
  },
  {
    value: 'month',
    display: 'external_calendar_settings_component.month'
  },
  {
    value: 'agenda',
    display: 'external_calendar_settings_component.agenda'
  },
  {
    value: 'weekResources',
    display: 'general.resource'
  }
];

export const CALENDAR_WEEK_START_DAY = [
  {
    value: 'sunday',
    display: 'event_time_slots.sunday'
  },
  {
    value: 'monday',
    display: 'event_time_slots.monday'
  },
  {
    value: 'tuesday',
    display: 'event_time_slots.tuesday'
  },
  {
    value: 'wednesday',
    display: 'event_time_slots.wednesday'
  },
  {
    value: 'thursday',
    display: 'event_time_slots.thursday'
  },
  {
    value: 'friday',
    display: 'event_time_slots.friday'
  },
  {
    value: 'saturday',
    display: 'event_time_slots.saturday'
  },
];

// More calendar requests than this within the window can only come from a loop.
export const CALENDAR_REQUEST_LIMIT = 20;
export const CALENDAR_REQUEST_WINDOW_MS = 10_000;
export const CALENDAR_REQUEST_PAUSE_MS = 30_000;
// The server never blocks a caller for longer than 5 minutes.
export const CALENDAR_REQUEST_MAX_PAUSE_MS = 300_000;
// While paused, a blocked load repeats the toast at most this often.
export const CALENDAR_PAUSED_TOAST_INTERVAL_MS = 10_000;

// Ceiling per `availabilities/calendar` request; a window request normally carries 6-10 ids.
export const RESOURCE_RANGE_WORKER_CHUNK_SIZE = 200;
// Range columns are Zurich-local, the visible range is viewer-local — pad by a day either side.
export const RESOURCE_RANGE_PAD_DAYS = 1;
// Columns loaded on each side of the visible resource-view columns.
export const RESOURCE_RANGE_BUFFER_COLUMNS = 3;
// Debounce for the Bryntum resource-view scroll listener.
export const RESOURCE_RANGE_SCROLL_DEBOUNCE_MS = 150;
// appointments/calendar is chunked into sequential worker groups of this size.
export const CALENDAR_EVENT_WORKER_CHUNK_SIZE = 50;
// The client cache keeps at most this many recently-touched weeks; older cells are evicted.
export const CALENDAR_CACHE_MAX_WEEKS = 12;
// An overlay week loaded longer ago than this is refetched when shown again.
export const CALENDAR_CACHE_TTL_MS = 60_000;
